import { defineComponent as _defineComponent } from 'vue'
import NavigationBar from "@/components/shared/NavigationBar.vue";
import Page from "@/components/shared/Page.vue";
import { useLineStore } from "@/stores/lineStore";
import { computed, inject, onMounted, ref } from "vue";
import { IContact } from "@/domain/entities/lineInfo";
import useFormattingPhoneNumber from "@/use/useFormattingPhoneNumber";
import { PROVIDE_KEY_SHOW_ERROR_MODAL, ShowErrorModal } from "@/types";
import ScrollTopControl from "@/components/shared/ScrollTopControl.vue";
import { useSystemStore } from "@/stores/systemStore";


const __default__ = {
  name: "Contact",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;

const lineStore = useLineStore();
const systemStore = useSystemStore();

const scrollContainerRef = ref<HTMLElement>();

// 시간과 분을 두 자리 숫자 형태로 포매팅
const formatTime = (hour: number, minute: number) => {
  return `${hour.toString().padStart(2, "0")}:${minute
    .toString()
    .padStart(2, "0")}`;
};

const getAvailableContactTime = (contact: IContact) => {
  const beginTime = formatTime(
    contact.contactBeginHour,
    contact.contactBeginMin
  );
  const endTime = formatTime(contact.contactEndHour, contact.contactEndMin);

  return `${beginTime}~${endTime}`;
};

const contactsByCampusMap = ref<Map<string, IContact[]>>(new Map());

// displayOrder 순서에 맞게 정렬
const sortedContactsEntries = computed((): [string, IContact[]][] =>
  [...systemStore.campusList]
    .sort((a, b) => a.displayOrder - b.displayOrder)
    .filter((campus) => contactsByCampusMap.value.has(campus.name))
    .map(
      (campus) =>
        [campus.name, contactsByCampusMap.value.get(campus.name) || []] as [
          string,
          IContact[]
        ]
    )
);

const getContactInfo = async () => {
  const fetchResult = await lineStore.getContactList();
  if (!fetchResult.isSuccess) {
    showErrorModal("고객지원 정보오류", "고객지원 정보를 가져올 수 없습니다.");
    return;
  }

  fetchResult.data?.forEach((contact) => {
    const campusName = contact.campusName;
    if (contactsByCampusMap.value.has(campusName)) {
      contactsByCampusMap.value.get(campusName)?.push(contact);
    } else {
      contactsByCampusMap.value.set(campusName, [contact]);
    }
  });
};

onMounted(() => {
  getContactInfo();
});

const __returned__ = { showErrorModal, lineStore, systemStore, scrollContainerRef, formatTime, getAvailableContactTime, contactsByCampusMap, sortedContactsEntries, getContactInfo, NavigationBar, Page, get useFormattingPhoneNumber() { return useFormattingPhoneNumber }, ScrollTopControl }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})